script<template>
  <div style="padding-bottom: 5rem" class="ad-apply">
    <div class="first-part">
      <van-field
        v-if="adCopies.length === 0"
        readonly
        clickable
        name="picker"
        :value="adContent.dealerType"
        label="门店类型"
        placeholder="请选择"
        @click="shopPicker = true"
      />
      <van-divider v-if="adCopies.length === 0" />
      <van-field
        v-if="adCopies.length == 0"
        readonly
        clickable
        name="picker"
        :value="productBrand"
        label="品牌类型"
        placeholder="请选择"
        @click="brandPicker = true"
      />
      <van-divider v-if="adCopies.length === 0" />
      <van-field
        v-if="adCopies.length == 0"
        readonly
        clickable
        name="picker"
        :value="adContent.advertType"
        label="广告类型"
        placeholder="门头招牌"
        @click="typePicker = false"
      />
      <van-divider v-if="adCopies.length === 0" />
      <van-field
        readonly
        clickable
        name="picker"
        :value="adContent.materialQuality"
        label="材质"
        placeholder="请选择"
        @click="texturePicker = true"
      />
      <van-divider />
      <div class="content-title">版面示例</div>
      <div class="example-img">
        <img
          :src="demoImg"
          alt
          style="width: 100%; height: 100%"
          ref="layoutImg"
        />
      </div>
    </div>
    <div class="second-part">
      <van-row type="flex">
        <van-col span="23">
          <van-field
            v-model="adContent.longs"
            type="number"
            label="广告长度"
            placeholder="请输入长度"
          />
        </van-col>
        <van-col span="1">米</van-col>
      </van-row>
      <van-divider />
      <van-row type="flex">
        <van-col span="23">
          <van-field
            v-model="adContent.height"
            type="number"
            label="广告高度"
            placeholder="请输入高度"
          />
        </van-col>
        <van-col span="1">米</van-col>
      </van-row>
      <van-divider />
      <div class="content-title">广告内容</div>
      <div class="ad-request">
        <van-field
          v-model="adContent.content"
          rows="2"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="如对版面及内容有其他要求,请详细填写"
          show-word-limit
        />
      </div>
      <div class="content-title">
        <p>实景图片</p>
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="4"
          :after-read="afterRead"
          :before-delete="beforeDelete"
          :before-read="beforeRead"
        />
      </div>
    </div>
    <div class="third-part">
      <div v-for="(item, index) in adCopies" :key="index">
        第{{ index + 1 }}份广告预估费用:
        <span class="price">
          {{ item.estimateCost1 }}
        </span>
      </div>
      <div>
        第{{ adCopies.length + 1 }}份广告预估费用:
        <span class="price">
          {{ (adContent.estimateCost1 = estimateCost1) }}
        </span>
      </div>
      广告预估总费用: <span class="price">{{ estimateTotalCost1 }}</span>
    </div>
    <div class="tips">
      注意：系统预估的广告费用可能与广告实际安装的费用存在偏差；
      广告费用核销时，以哈弗公司财务部最终核算的金额为准。
    </div>
    <van-popup v-model="shopPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="shopColumns"
        @confirm="onShop"
        @cancel="shopPicker = false"
      />
    </van-popup>
    <van-popup v-model="brandPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="brandColumns"
        @confirm="onBrand"
        @cancel="brandPicker = false"
      />
    </van-popup>
    <van-popup v-model="typePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @confirm="onConfirm"
        @cancel="typePicker = false"
      />
    </van-popup>
    <van-popup v-model="texturePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="textureColumns"
        @confirm="onTexture"
        @cancel="texturePicker = false"
      />
    </van-popup>
    <van-button class="add-ad" type="info" @click="addAd">新增一份</van-button>
    <van-button type="primary" @click="nextStep">下一步</van-button>
  </div>
</template>
<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import * as imageConversion from "image-conversion";
export default {
  data() {
    return {
      shopColumns: ["汽修厂", "专卖店"],
      shopPicker: false,
      brandColumns: ["原动力", "力猛", "原动力+力猛"],
      brandPicker: false,
      typeColumns: ["门头招牌"],
      typePicker: false,
      textureColumns: [
        "纯灯布",
        "铁架+灯布",
        "彩钢板+PVC字",
        "铝塑板+PVC字",
        "铝塑板+平面发光字",
      ],
      texturePicker: false,
      demoImg: "",
      productBrand: "",
      adContent: {
        dealerType: null,
        advertType: "门头招牌",
        materialQuality: "",
        longs: "",
        height: "",
        content: "",
        realSceneImg: [],
        estimateCost1: null,
        estimateCost2: "123",
        pageExample: "",
      },
      fileList: [],
      adCopies: [],
      estimateTotalCost: 0,
    };
  },
  computed: {
    estimateCost1: function () {
      switch (this.adContent.materialQuality) {
        case "纯灯布": {
          let adPrice = Math.ceil(
            40 * this.adContent.longs * this.adContent.height * 1.2
          );
          adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
          return adPrice;
        }
        case "铁架+灯布": {
          let adPrice = Math.ceil(
            70 * this.adContent.longs * this.adContent.height * 1.2
          );
          adPrice = adPrice < 300 && adPrice > 0 ? 300 : adPrice;
          return adPrice;
        }
        case "彩钢板+PVC字": {
          let adPrice = Math.ceil(
            240 * this.adContent.longs * this.adContent.height * 1.2
          );
          adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
          return adPrice;
        }
        case "铝塑板+PVC字": {
          let adPrice = Math.ceil(
            270 * this.adContent.longs * this.adContent.height * 1.2
          );
          adPrice = adPrice < 500 && adPrice > 0 ? 500 : adPrice;
          return adPrice;
        }
        case "铝塑板+平面发光字": {
          let adPrice = Math.ceil(
            340 * this.adContent.longs * this.adContent.height * 1.2
          );
          adPrice = adPrice < 800 && adPrice > 0 ? 800 : adPrice;
          return adPrice;
        }
        default:
          return 0;
      }
    },
    estimateTotalCost1: function () {
      return this.estimateCost1 + this.estimateTotalCost;
    },
  },
  created() {
    if (localStorage.getItem("content")) {
      Dialog.confirm({
        title: "注意!",
        confirmButtonText: "继续编辑",
        cancelButtonText: "重新申请",
        message: "检测到您有未提交的广告申请,重新申请后将会删除记录信息",
      })
        .then(() => {
          this.$router.push("/agency/editAd");
        })
        .catch(() => {
          localStorage.removeItem("content");
          localStorage.removeItem("apply");
          localStorage.removeItem("estimateTotalCost");
          localStorage.removeItem("productBrand");
          localStorage.removeItem("minimum");
          localStorage.removeItem("ratio");
          localStorage.removeItem("allStockPrice");
        });
    } else {
      Dialog.confirm({
        title: "温馨提示",
        confirmButtonText: "我已了解",
        message:
          "欢迎您与哈弗公司共同签署《广告投放协议》并使用哈弗平台服务！为了维护您自身权益，建议您仔细阅读并按照页面提示填写信息。如果您不同意本协议或其中任何条款约定，您应立即停止签署程序。",
      })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          wx.closeWindow();
        });
    }
    console.log(this.adCopies, "adCopies=>");
  },
  methods: {
    //初始化数据
    initData() {
      this.demoImg = "";
      this.fileList = [];
      this.adContent = {
        materialQuality: "",
        longs: "",
        height: "",
        content: "",
        realSceneImg: [],
        estimateCost1: null,
        estimateCost2: "123",
        pageExample: "",
      };
    },
    // 门店类型
    onShop(value, index) {
      console.log(index);
      if (index === 0) {
        switch (this.adContent.materialQuality) {
          case "纯灯布":
            this.demoImg = require("../../assets/factory_stand.jpg");
            break;
          case "铁架+灯布":
            this.demoImg = require("../../assets/factory_stand.jpg");
            break;
          case "彩钢板+PVC字":
            this.demoImg = require("../../assets/factory_panel_PVC.jpg");
            break;
          case "铝塑板+PVC字":
            this.demoImg = require("../../assets/factory_plate_PVC.jpg");
            break;
          case "铝塑板+平面发光字":
            this.demoImg = require("../../assets/factory_plate_character.jpg");
            break;
          default:
            this.demoImg = "";
            break;
        }
      } else {
        switch (this.adContent.materialQuality) {
          case "纯灯布":
            this.demoImg = require("../../assets/shop_stand.jpg");
            break;
          case "铁架+灯布":
            this.demoImg = require("../../assets/shop_stand.jpg");
            break;
          case "彩钢板+PVC字":
            this.demoImg = require("../../assets/shop_panel_PVC.jpg");
            break;
          case "铝塑板+PVC字":
            this.demoImg = require("../../assets/shop_plate_PVC.jpg");
            break;
          case "铝塑板+平面发光字":
            this.demoImg = require("../../assets/shop_plate_character.jpg");
            break;
          default:
            this.demoImg = "";
            break;
        }
      }
      this.adContent.dealerType = value;
      this.shopPicker = false;
    },
    // 品牌类型
    onBrand(value) {
      this.productBrand = value;
      this.brandPicker = false;
    },
    // 广告类型
    onConfirm(value) {
      this.adContent.advertType = value;
      this.typePicker = false;
    },
    // 材质
    onTexture(value, index) {
      if (this.adContent.dealerType === null) {
        Toast("请选择门店类型");
        this.texturePicker = false;
        return;
      }
      console.log(index, "材质");
      /*switch (index) {
        case 0:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/factory_stand.jpg")
              : require("../../assets/shop_stand.jpg");
          break;
        case 1:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/factory_panel_PVC.jpg")
              : require("../../assets/shop_panel_PVC.jpg");
          break;
        case 2:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/factory_plate_PVC.jpg")
              : require("../../assets/shop_plate_PVC.jpg");
          break;
        case 3:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/factory_plate_character.jpg")
              : require("../../assets/shop_plate_character.jpg");
          break;
        default:
          break;
      }*/
      switch (index) {
        case 0:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/texture/factory/factory_stand.jpg")
              : require("../../assets/texture/shop/shop_stand.jpg");
          break;
        case 1:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/texture/factory/factory_iron.jpg")
              : require("../../assets/texture/shop/shop_iron.jpg");
          break;
        case 2:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/texture/factory/factory_panel_PVC.jpg")
              : require("../../assets/texture/shop/shop_panel_PVC.jpg");
          break;
        case 3:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/texture/factory/factory_plate_PVC.jpg")
              : require("../../assets/texture/shop/shop_plate_PVC.jpg");
          break;
        case 4:
          this.demoImg =
            this.adContent.dealerType === "汽修厂"
              ? require("../../assets/texture/factory/factory_plate_character.jpg")
              : require("../../assets/texture/shop/shop_plate_character.jpg");
          break;
        default:
          break;
      }
      this.adContent.materialQuality = value;
      this.texturePicker = false;
    },
    // 上传图片前
    beforeRead(file) {
      console.log("file :>> ", file);
      if (file.type != "image/png" && file.type != "image/jpeg") {
        this.$toast("请上传png、jpeg图片格式");
        return false;
      }
      return new Promise((resolve) => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then((res) => {
            let files = new window.File([res], file.name, {
              type: file.type,
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then((res) => {
          // console.log(res);
          file.status = "done";
          file.message = "上传成功";
          this.adContent.realSceneImg.push(res.url);
        })
        .catch((err) => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          Toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      this.fileList.splice(detail.index, 1);
      this.adContent.realSceneImg.splice(detail.index, 1);
    },
    // 新增一份
    addAd() {
      if (this.adCopies.length === 4) {
        this.$toast("最多做四份");
      } else {
        if (!this.handleRules()) {
          return;
        }
        // 回到顶部
        let ispeed = Math.floor(-this.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        // 存储数据
        this.filterData();
        // 初始化表单
        this.initData();
      }
    },
    // 下一步
    nextStep() {
      if (!this.handleRules()) {
        return;
      }
      this.filterData();
      // console.log(this.adCopies);
      localStorage.setItem("content", JSON.stringify(this.adCopies));
      localStorage.setItem("productBrand", this.productBrand);
      localStorage.setItem("estimateTotalCost", this.estimateTotalCost);
      localStorage.removeItem("apply");
      this.$router.push("/agency/ad-agreement");
    },
    //校验
    handleRules() {
      if (this.adContent.dealerType === null) {
        this.$toast("请选择门店类型");
        return false;
      }
      if (this.adContent.materialQuality === "") {
        this.$toast("请选择材质");
        return false;
      }
      if (this.adContent.longs.trim() === "") {
        this.$toast("请输入广告长度");
        return false;
      }
      if (this.adContent.height.trim() === "") {
        this.$toast("请输入广告高度");
        return false;
      }
      if (this.adContent.content.trim() === "") {
        this.$toast("请输入广告内容");
        return false;
      }
      if (this.adContent.realSceneImg.length === 0) {
        this.$toast("请上传实景图片");
        return false;
      }
      return true;
    },
    //数据过滤
    filterData() {
      if (this.adCopies.length === 0) {
        //门店类型
        this.adContent.dealerType =
          this.adContent.dealerType === "汽修厂" ? 1 : 2;
        // 品牌类型
        switch (this.productBrand) {
          case "原动力":
            this.productBrand = 1;
            break;
          case "力猛":
            this.productBrand = 2;
            break;
          case "原动力+力猛":
            this.productBrand = 3;
            break;
        }
        //广告类型
        this.adContent.advertType =
          this.adContent.advertType === "门头招牌" ? 1 : 2;
      } else {
        this.adContent.dealerType = this.adCopies[0].dealerType;
        this.adContent.advertType = this.adCopies[0].advertType;
      }
      //材质
      switch (this.adContent.materialQuality) {
        case "铁架+灯布":
          this.adContent.materialQuality = 1;
          break;
        case "彩钢板+PVC字":
          this.adContent.materialQuality = 2;
          break;
        case "铝塑板+PVC字":
          this.adContent.materialQuality = 3;
          break;
        case "铝塑板+平面发光字":
          this.adContent.materialQuality = 4;
          break;
        case "纯灯布":
          this.adContent.materialQuality = 5;
          break;
      }
      // 示例图
      this.adContent.pageExample = this.$refs.layoutImg.src;
      // 实景图
      this.adContent.realSceneImg =
        this.adContent.realSceneImg.length === 0
          ? ""
          : this.adContent.realSceneImg.join(",");
      //总价
      this.estimateTotalCost =
        this.adContent.estimateCost1 + this.estimateTotalCost;
      //提交数据
      console.log(this.estimateTotalCost, "this.estimateTotalCost=>");
      this.adCopies.push(this.adContent);
    },
  },
};
</script>
<style lang="scss" scoped>
.van-cell {
  padding: 0;
}

.van-cell:nth-of-type(1) {
  padding-top: 16px;
}

.van-cell:not(:last-child)::after {
  display: none;
}

.van-divider {
  border-color: #eaeaea;
}

.first-part {
  padding: 0 20px;
  border-bottom: 15px solid #eaeaea;

  .example-img {
    width: 100%;
    height: 250px;
    margin: 0 auto;
    margin-bottom: 10px;
    border: 1px solid #eaeaea;
  }
}

.second-part {
  padding: 0 20px;
  border-bottom: 15px solid #eaeaea;
}

.third-part {
  text-align: left;
  padding: 20px 20px;
  padding-bottom: 10px;

  .price {
    color: red;
  }
}

.tips {
  padding: 20px;
  padding-top: 0;
  font-size: 14px;
  text-align: left;
  color: red;
}

.content-title {
  margin-bottom: 5px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
}

.add-ad {
  margin-right: 20px;
}

.van-row--flex {
  align-items: baseline;
}
</style>
<style lang="scss">
.ad-apply {
  .van-field__control {
    text-indent: 70px;
  }

  .van-field__label {
    text-align: left;
    font-weight: 600;
  }

  .van-uploader__upload {
    background-color: #ccc;
  }

  .van-uploader {
    position: static;
  }

  .van-dialog__message {
    font-size: 14px;
  }

  .ad-request {
    margin-bottom: 20px;
    border: 1px solid #eaeaea;

    .van-field__control {
      text-indent: 10px;
    }

    .van-cell:nth-of-type(1) {
      padding-top: 0;
    }
  }
}
</style>
